var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-nested-container"},[_c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},[_vm._t("tablist")],2),_c('div',{staticClass:"tab-content "},[_vm._t("tabcontent")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }